import { createReducer, createAction } from 'redux-starter-kit';
import * as actionTypes from '../../constants/actions';

//TODO: use the constants for these
const loginSuccess = createAction('LOGIN_USER_SUCCESS');
const logoutSuccess = createAction('LOGOUT_USER_SUCCESS');
const defaultState = { user: {}, isAuthenticated: false };

const sessionReducer = createReducer(defaultState, {
  [loginSuccess]: (state, action) => {
    console.log('IN A SET SESSION REDUCER YO: ', state, action);
    return Object.assign({}, state, { isAuthenticated: true, user: action.user });
  },
  [logoutSuccess]: (state, action) => Object.assign({}, state, defaultState),
  default:
    console.log('default session reducer...', this)
});

export default sessionReducer;



// WEBPACK FOOTER //
// ./src/reducers/session/index.js